import { gsap } from "gsap";

export function accordion() {
  const isOpen = "is-open";

  const openAnimation = (content) => {
    content.style.height = "auto";
    const targetHeight = content.offsetHeight;
    content.style.height = "0";

    return gsap.to(content, {
      height: targetHeight,
      duration: 0.3,
      ease: "power2.out",
      overwrite: true,
      onComplete: () => {
        content.style.height = "auto";
      },
    });
  };

  const closeAnimation = (content, onComplete) => {
    const currentHeight = content.offsetHeight;

    return gsap.fromTo(
      content,
      { height: currentHeight },
      {
        height: 0,
        duration: 0.3,
        ease: "power2.out",
        overwrite: true,
        onComplete,
      }
    );
  };

  const initAccordion = (selector, summarySelector, contentSelector, options = {}) => {
    const accordions = document.querySelectorAll(selector);

    accordions.forEach((accordion) => {
      const summary = accordion.querySelector(summarySelector);
      const content = accordion.querySelector(contentSelector);
      const icons = options.iconSelector
        ? accordion.querySelectorAll(options.iconSelector)
        : [];

      if (!summary || !content) return;

      if (options.keepOpen) {
        accordion.setAttribute("open", "");
      }

      const handleToggle = (event) => {
        event.preventDefault();

        if (options.keepOpen) {
          accordion.setAttribute("open", "");
        }

        if (accordion.classList.contains(isOpen)) {
          accordion.classList.remove(isOpen);
          closeAnimation(content, () => {
            if (!options.keepOpen) {
              accordion.removeAttribute("open");
            }
          }).restart();
        } else {
          accordion.classList.add(isOpen);
          if (!options.keepOpen) {
            accordion.setAttribute("open", "");
          }
          openAnimation(content).restart();
        }
      };

      summary.addEventListener("click", handleToggle);
      icons.forEach((icon) => {
        icon.addEventListener("click", handleToggle);
      });

      if (options.initialClosed && !accordion.classList.contains(isOpen)) {
        gsap.set(content, { height: 0 });
      }
    });
  };

  initAccordion(".js-accordion", ".js-accordion-summary", ".js-accordion-content");
  initAccordion(".js-accordion01", ".js-accordion01-summary", ".js-accordion01-content");
  initAccordion(".js-accordion02", ".js-accordion02-summary", ".js-accordion02-content", {
    iconSelector: ".js-accordion02-icon",
    initialClosed: true,
    keepOpen: true,
  });
}
